import { render, staticRenderFns } from "./AddAudioSpotModal.vue?vue&type=template&id=752831a4&"
import script from "./AddAudioSpotModal.vue?vue&type=script&lang=ts&"
export * from "./AddAudioSpotModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddAudioSpotModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports